import { useControlledField } from '~/components/v2/forms/HookFormControl'
import { InputCurrency, InputCurrencyProps } from '~/design_system'

/**
 * HookFormCurrencyInput
 *
 * Currency input field used with React Hook Forms formatting currency based on the ISO standards.
 *
 * All currency is displayed using the react-number-format component.
 *
 * See: https://storybook.beta.vndly.com/?path=/docs/libraries-react-hook-form-currency--docs
 */
export function HookFormCurrencyInput(props: Omit<InputCurrencyProps, 'onChange' | 'onBlur'>) {
  const { field, rules } = useControlledField({
    defaultValueFormatter({ defaultValue, rules }) {
      return rules.valueAsNumber ? Number(defaultValue) : defaultValue
    }
  })

  return (
    <InputCurrency
      {...field}
      {...props}
      valueAsNumber={rules.valueAsNumber || props.valueAsNumber}
      style={{ display: 'block' }}
    />
  )
}

HookFormCurrencyInput.displayName = 'HookFormCurrencyInput'
